import React from 'react';
import { string } from 'prop-types';

import * as helpers from './helpers';

const ChartArrow = ({ color, ...props }) => (
  <svg {...helpers.getSvgDimensionsProps(props)} {...props}>
    <path
      fill={color}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.19122 3.4657L1.30207 5.40626C1.00984 5.70644 0.529599 5.71289 0.22942 5.42066C-0.0707587 5.12843 -0.0772052 4.64819 0.215022 4.34801L3.45635 1.01848C3.60505 0.865736 3.80243 0.789045 4 0.789063C4.19757 0.789045 4.39495 0.865736 4.54365 1.01848L7.78498 4.34801C8.0772 4.64819 8.07076 5.12843 7.77058 5.42066C7.4704 5.71289 6.99016 5.70644 6.69793 5.40626L4.7083 3.36248V11.2714C4.7083 11.6903 4.36869 12.03 3.94976 12.03C3.53083 12.03 3.19122 11.6903 3.19122 11.2714V3.4657Z"
    />
  </svg>
);

ChartArrow.propTypes = {
  color: string.isRequired,
  ...helpers.iconDimensionsPropTypes,
};

ChartArrow.defaultProps = {
  ...helpers.getDefaultIconDimensionsProps(8, 11),
};

export default ChartArrow;



// WEBPACK FOOTER //
// ./src/components/svg-icon/icons/chart-arrow.js